import React, { useState } from "react";
import { GoogleLogin } from "@react-oauth/google";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { loginWithGoogle } from "../../Redux/actions/authActions";
import { toast } from "react-toastify";
import { hasUserFilledSurvey } from "../../Redux/actions/commonActtion";
import { Scrollx_animate, scrollxLogo } from "../../assets/icons";
import LoaderGlobal from "../../Components/Loader/LoaderGlobal";
import "../Login/login.css";
let body = {
  googleToken: "",
};

const SignUpWithGoogle = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [signInLoading, setSignInLoading] = useState(false);

  const handleSuccess = async (credentialResponse) => {
    setSignInLoading(true);
    if (credentialResponse?.credential) {
      body.googleToken = credentialResponse?.credential;
      const res = await dispatch(loginWithGoogle(body));
      if (res.success && !res.alreadyAuser) {
        setSignInLoading(false);
        navigate("/new_user_survey");
      }
      if (res.success && res.alreadyAuser) {
        setSignInLoading(false);
        navigate("/dashboard");
        const userFilledSurvey = await hasUserFilledSurvey();
        localStorage.setItem(
          "userFilledSurvey",
          JSON.stringify(userFilledSurvey)
        );
      } else if (!res.success) {
        // toast.error('something wrongs !');
        setSignInLoading(false);
        alert("something wrong ");
      }
    }
  };

  const handleError = () => {
    alert("Login Failed");
  };

  return (
    <div className="rounded-xl w-fit pt-3 flex justify-center items-center text-center ">
      {signInLoading && (
        <div className="modal-overlayLoaderGoogle">
          <img
            src={Scrollx_animate}
            className="absolute opacity-80"
            width="120px"
            height="120px"
          />
          <p className="mt-[8rem] text-[0.9rem] text-white">Sign in with Google...</p>
          {/* <LoaderGlobal /> */}
        </div>
      )}

      <GoogleLogin
        onSuccess={handleSuccess}
        onError={handleError}
        buttonText="Login with Google"
      />
    </div>
  );
};

export default SignUpWithGoogle;
